import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RestApi } from '../RestApi/restApi';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageSettingsService } from './local-storage-settings.service';


interface JsignalInfo {   
  statusMessage: any;
  error: boolean;
  data: any[];
}
interface Product {
  id: string;
  name: string;
}

// added by Rahul vk on 24-10-2024
  interface BasketTerm {
  type: string;        // TERM or SMQ
  level?: string;      // PT__V, LLT__V (only for TERM)
  code: string;
  name: string;
  provenance: string;  // DIRECT_TERM, SMQ_NARROW etc
  scope?: string;      // only for SMQ
}

@Injectable({
  providedIn: 'root'
})
export class JsignalService {

  private headers = new HttpHeaders({
    "Content-Type": "application/json"
    });

    private headerpart = new HttpHeaders({
      'enctype': 'multipart/form-data',  // Ensure the correct encoding
    });

    private studyData: any = null;

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi,
    private router: Router,
     private localStorageSettings: LocalStorageSettingsService
  ) { }

    getTemplateByName(templateName: string): Observable<any> {
    return this.http.get<JsignalInfo>(`${this.restAPI.GET_DEFAULT_TEMPLATE}/get/${encodeURIComponent(templateName)}`,{ headers: this.headers });
  }
  /**
   * @author Rahul vk
   * @Date 14-11-2025
   * @Desc Added product interface to this method  
   */
    getProductList(): Observable<Product[]> {
      let UserId=this.localStorageSettings.getSettings("UserId");
      return this.http.get<Product[]>(this.restAPI.GET_ASSIGNED_PRODUCTS_FOR_ROLE+'/'+UserId,{ headers: this.headers } );
    }
  
   getProductMetadata(productNames: string | string[]): Observable<any[]> {
    const namesArray = Array.isArray(productNames)? productNames: [productNames];return this.http.post<any[]>(this.restAPI.GET_PRODUCT_METADATA,namesArray,{ headers: this.headers });
  }
  
    createProductStrategies(payload: any[]): Observable<any> {
    return this.http.post<JsignalInfo>(this.restAPI.CREATE_STRATEGY, payload, { headers: this.headers });
    }
  
    getAllProductStrategies(): Observable<any[]> {
    return this.http.get<JsignalInfo[]>(this.restAPI.GET_ALL_STRATEGY, { headers: this.headers });
    }
  
    updateProductStrategy(id: number, data: any): Observable<any> {
    return this.http.put<JsignalInfo>(`${this.restAPI. UPDATE_STRATEGY}/${id}`,data,{ headers: this.headers });
    }
  
    deleteProductStrategy(id: number): Observable<any> {
    return this.http.delete<JsignalInfo>(`${this.restAPI. DELETE_STRATEGY}/${id}`,{ headers: this.headers});
    }
  
    createProductStrategyTemplate(data: any): Observable<any> {
    return this.http.post<JsignalInfo>(this.restAPI.CREATE_TEMPLATE, data, { headers: this.headers });
    }
  
    getAllTemplatesNonDefault(): Observable<any> {
    return this.http.get<JsignalInfo>(this.restAPI.GETALL_TEMPLATE_NONDEFAULT, { headers: this.headers });
    }
  
  updateProductStrategyTemplate(id: number, data:any): Observable<any> {
  return this.http.put<JsignalInfo>(`${this.restAPI.UPDATE_TEMPLATE}/${id}`,data,{ headers: this.headers });
  }
  
  deleteProductStrategyTemplate(id: number): Observable<any> {
  return this.http.delete<JsignalInfo>(`${this.restAPI. DELETE_TEMPLATE}/${id}`,{ headers: this.headers});
   }
  getAllTemplates(): Observable<any[]> {
  return this.http.get<JsignalInfo[]>(this.restAPI.GETALL_TEMPLATE, { headers: this.headers });
   }
  
  getUniqueTemplateName(Name: String): Observable<any> {
  return this.http.get<JsignalInfo>(`${this.restAPI.GET_UNIQUE_TEMPLATE_NAME}/${Name}`,{ headers: this.headers});
  }
  
  getAllProductStrategiesForReview(userId: any): Observable<any[]> {
    const url = this.restAPI.GET_PSS_FOR_REVIEW.replace('{userId}', String(userId));
    return this.http.get<any[]>(url, { headers: this.headers });
  }
  
  approveAction(Id: number, action: string,comments: string): Observable<any> {
  const url = this.restAPI.APPROVER_ACTION.replace('{Id}', Id.toString());
  const params = new HttpParams().set('action', action);

  // send params as query string, body can be {}
  return this.http.post<JsignalInfo>(url, comments, { params });
  }

  getProductStrategyById(id: any): Observable<any> {
  return this.http.get<JsignalInfo>(`${this.restAPI.GET_PSS_BY_ID}/${id}`,{ headers: this.headers});
  }
 
  //added by kameshwar.d @date 09-09-2025
  uploadTemplates(formData: FormData): Observable<any> {
    return this.http.post(this.restAPI.UPLOAD_TEMPLATES, formData, { responseType: 'text' });
  }
         //added by kameshwar.d @date 09-09-2025

 download_zip(templateId: string) {
  const url = `${this.restAPI.DOWNLOAD_TEMPLATES}?templateId=${templateId}`;

  return this.http.post(url, null, {
    responseType: 'blob' 
  });
}

  AddNewComment( data:any): Observable<any> {
  return this.http.post<JsignalInfo>(this.restAPI.ADD_NEW_COMMENT,data,{ headers: this.headers });
  }

  deleteComment( data:any): Observable<any> {
  return this.http.post<JsignalInfo>(this.restAPI.DELETE_COMMENT,data,{ headers: this.headers });
  }

  EditComment( data:any): Observable<any> {
  return this.http.post<JsignalInfo>(this.restAPI.EDIT_COMMENT,data,{ headers: this.headers });
  }

  replyComment( data:any): Observable<any> {
  return this.http.post<JsignalInfo>(this.restAPI.REPLY_TO_COMMENT,data,{ headers: this.headers });
  }

  updateCommentStatus(comment: any, status: string): Observable<any> {
    const url = this.restAPI.UPDATE_COMMENT_STATUS;   
    const params = new HttpParams().set('status', status);

    return this.http.post<any>(url, comment, { params });
  }

  getComments(strategyId: number): Observable<any> {
  const url = `${this.restAPI.GET_COMMENTS}/${strategyId}`;
  return this.http.get<any>(url);
  }

  reviewComplete(Id: number, comments: string): Observable<any> {
  const url = this.restAPI.REVIEWE_COMPLETE.replace('{Id}', Id.toString());
  return this.http.post<JsignalInfo>(url, comments, { headers: this.headers });
}

    getSection(title: string, id: string): Observable<string> {
    const params = new HttpParams()
      .set('title', title)
      .set('id', id);

    return this.http.post<string>(this.restAPI.GET_SECTION, null, { params });
  }

     getAllActivitesBasedOnRole(userId:any,WorkspaceId:string): Observable<any> {
    const url = this.restAPI.GET_ALL_SCHEDULED_REVIEW_ACTIVITIES.replace('{userId}', userId).replace('{workSpaceId}', WorkspaceId);
    return this.http.get<JsignalInfo>(url, { headers: this.headers });
    }

    selfAssignCurrentUserToActivity(scheduleId:any,userId:any): Observable<any> {
    const url = `${this.restAPI.SELF_ASSIGN_USER_TO_ACTIVITY}/${scheduleId}/assign-user/${userId}`;
    return this.http.post<JsignalInfo>(url, { headers: this.headers });
    }

    removeAssignedUSerFromActivity(scheduleId:any): Observable<any> {
    const url = `${this.restAPI.REMOVE_ASSIGNED_USER_TO_ACTIVITY}/${scheduleId}/unassign-user`;
    return this.http.post<JsignalInfo>(url, { headers: this.headers });
    }

    startReviewActivity(scheduleId:any,userId:any): Observable<any> {
    const url = `${this.restAPI.START_REVIEW_ACTIVITY}/${scheduleId}/start/${userId}`;
    return this.http.post<JsignalInfo>(url, { headers: this.headers });
    }

    completeReviewActivity(scheduleId:any,formData): Observable<any> {
    const url = this.restAPI.COMPLETE_REVIEW_ACTIVITY.replace('{scheduleId}', scheduleId);
    return this.http.post<JsignalInfo>(url,formData, { headers: this.headerpart });
    }

  // Un-Comment the below Code to Ignore White-Space Changes in the Json 
   normalize(obj: any): any {
    // if (typeof obj === 'string') {
    //   return obj.replace(/\s+/g, ' ').trim().toLowerCase();
    // } else if (Array.isArray(obj)) {
    //   return obj.map(item => this.normalize(item));
    // } else if (obj && typeof obj === 'object') {
    //   const normalized: any = {};
    //   Object.keys(obj).forEach(key => {
    //     normalized[key] = this.normalize(obj[key]);
    //   });
    //   return normalized;
    // }
    return obj; // numbers, booleans, null
  }

  // Generate SHA-256 hash of normalized JSON
   async getJsonHash(obj: any): Promise<string> {
    const normalized = this.normalize(obj);
    const str = JSON.stringify(normalized);
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    console.log(hashBuffer);
    console.log(hashArray.toString());
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  // @note:- START_REVIEW_ACTIVITY --Using this Common restApi for review activities for the url :- /review-activities
    createNewAdhocReviewActivity(pssId:any,payload:any): Observable<any> {
    const url = `${this.restAPI.START_REVIEW_ACTIVITY}/${pssId}/createAdhocActivity`;
    return this.http.post<JsignalInfo>(url, payload,{ headers: this.headers });
    }

  getAllLatestApprovedPss(): Observable<any[]> {
  return this.http.get<JsignalInfo[]>(this.restAPI.GET_LATEST_APPROVED_PSS, { headers: this.headers });
   }
  
  toYYYYMMDD(date: any): string {
  if (!date) return "";
  const d = new Date(date);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  }

  deleteAddHocReviewActivityByActivityId(activityId:any){
  const url = this.restAPI.DELETE_AD_HOC_ACTIVITY.replace('{id}', activityId);
    return this.http.delete<JsignalInfo>(url, { headers: this.headerpart });
  }
  
getApprovedLatestPssDocument(strategyId: any, type: 'WORD' | 'PDF') {
  const url = this.restAPI.DOWNLOAD_DOCUMNET_FOR_APPROVED_LATEST_PSS
    .replace('{strategyId}', strategyId);

  return this.http.get(url, {
    headers: this.headers,
    params: { type },
    responseType: 'blob',
    observe: 'response'
  });
}


 setStudy(data: any) {
    this.studyData = data;
  }

  getStudy() {
    return this.studyData;
  }

  clear() {
    this.studyData = null;
  }

  // Added by Rahul Vk 
searchMeddra(term: string) {
   return this.http.get<any>(
    `${this.restAPI.getMedrasearchdata}/${encodeURIComponent(term)}/searchterms`
  );
}

  createBasket(payload: any): Observable<any> {
    return this.http.post<JsignalInfo>(this.restAPI.createMeddraBasket, payload);
  }

  getMedraBasketOfSelectedMedraVersion(meddraVersion: any): Observable<any> {
  const url = `${this.restAPI.GetMEDRABASKETS_OF_SELECTED_MEDDRA_VERSION}/${meddraVersion}`;
  return this.http.get<any>(url);
  }

addTermsToSelectedBasket(basketId: number, terms: BasketTerm[],dataType:string): Observable<any> {
    const url = this.restAPI.ADD_TERMS_TO_SELCTED_BASKET.replace('{basketId}', basketId.toString());

  const url1 = url.replace('{dataType}', dataType.toString());

  return this.http.post<JsignalInfo>(url1, terms, { headers: this.headers });
}

getBasketDetails(basketId: number): Observable<any> {
  const url = this.restAPI.GET_BASKET_DETAILS.replace('{basketId}', basketId.toString());
  return this.http.get<JsignalInfo>(url, { headers: this.headers });
}

updateBasketState(basketId: number, action: string): Observable<any> {
  const url = this.restAPI.UPDATE_BASKET_STATE
    .replace('{basketId}', basketId.toString());

  const params = { action };

  return this.http.post<any>(url, null, {
    headers: this.headers,
    params
  });
 
}

  autoTooltip(headerName: string) {
    return {
      headerTooltip: headerName,  // must be literal string
      tooltipValueGetter: (params: any) =>
        `${headerName}: ${params.value ?? ''}`
    };
  }
getTopLevelSMQs():Observable<any> {
    const url=this.restAPI.getMedDRASMQs
    return this.http.post<any>(url,{headers: this.headers})
  }
  getSMQChildren(request: any):Observable<any>  {
        const url=this.restAPI.getMedDRASMQs
    return this.http.post<any>(url,request, {headers: this.headers})

  }
  getSMQTerms(request: any):Observable<any>  {
        const url=this.restAPI.getMedDRASMQsleaf
    return this.http.post<any>(url,request, {headers: this.headers})

  }
getSmqsByPtTerm(
  ptTerm: string,
  version: string = 'latest',
  language: string = 'EN'
): Observable<any> {

  const url=this.restAPI.getMedDRASMQsByPtTerms

  const params = new HttpParams()
    .set('ptTerm', ptTerm)
    .set('version', version)
    .set('language', language);

  return this.http.get<any>(url, {
    params,
    headers: this.headers
  });
}
  getKeyChanges(fromDate: string, toDate: string): Observable<any[]> {
    const params = new HttpParams()
      .set('fromDate', fromDate)
      .set('toDate', toDate);
  const url=this.restAPI.getKeyChangesByDate

    return this.http.get<any[]>(url, { params  ,headers: this.headers});
  }

  getSignalDetectedProducts(userRole:any,productId: string): Observable<any[]> {
    const params = new HttpParams()
      .set('role', userRole)
      .set('ProductId',productId);
    
      const url=this.restAPI.GET_SIGNAL_DETECTED_PRODUCT
      
       return this.http.get<any[]>(url, { params  ,headers: this.headers});
    }
// Create new action
  createAction(actionDTO: any): Observable<any> {
    const url = this.restAPI.createAction;
    return this.http.post(url, actionDTO, { headers: this.headers });
  }

  // Update existing action
  updateAction(actionId: any, actionDTO: any): Observable<any> {
    return this.http.put(`${this.restAPI.updateAction}/${actionId}`, actionDTO, { headers: this.headers });
  }
  updateActionstate(actionId: any, actionDTO: any): Observable<any> {
  const url = this.restAPI.updateActionState.replace("{id}", actionId);

  return this.http.put(url, actionDTO, { headers: this.headers });
}

  // Get action by ID
  getActionById(actionId: string): Observable<any> {
    return this.http.get(`${this.restAPI.getActionById}/${actionId}`, { headers: this.headers });
  }

  // Get all actions with optional filters
  getActions(params?: any): Observable<any> {
    return this.http.get(this.restAPI.getAllActions, { params, headers: this.headers });
  }

  // Delete action
  deleteAction(actionId: string): Observable<any> {
    return this.http.delete(`${this.restAPI.deleteAction}/${actionId}`, { headers: this.headers });
  }
assignUserToAction(actionId: number, userId: string): Observable<any> {

  return this.http.put(
    `${this.restAPI.updateAction}/${actionId}/assign/${userId}`,
    null,   
    { headers: this.headers }
  );

}


// ------------------------------My Tasks -----------------------------------

     getAllTaskOfLoggedInUser(userId:any): Observable<any> {
    const url = this.restAPI.GET_USER_TASK.replace('{userId}', userId);
    return this.http.get<JsignalInfo>(url, { headers: this.headers });
    }
// -------------------Review Activity Configurations -------------------

insertReviewActivityConfigDetails(activityDetails:any): Observable<JsignalInfo> {
return this.http.post<JsignalInfo>(
    this.restAPI.CREATE_REVIEW_ACTIVITY_CONFIG,
    activityDetails,
    { headers: this.headers }
  );
}

// Get All Review Activity Configs
getAllReviewActivityConfigs(): Observable<any> {
  const workSpaceId = this.localStorageSettings.getSettings("WorkspaceId");
  const url = this.restAPI.GET_ALL_REVIEW_ACTIVITY_CONFIGS.replace('{workSpaceId}', workSpaceId);
  return this.http.get<any>(
    url,
    { headers: this.headers }
  );
}


// Get All Active Review Activity Configs
getAllActiveReviewActivityConfigs(): Observable<any> {
  const workSpaceId = this.localStorageSettings.getSettings("WorkspaceId");
  const url = this.restAPI.GET_ALL_ACTIVE_REVIEW_ACTIVITY_CONFIGS.replace('{workSpaceId}', workSpaceId);
  return this.http.get<any>(
    url,
    { headers: this.headers }
  );
}


getDefaultActivitiesBasedOnWorkSpaceId(): Observable<any> {
  const workSpaceId = this.localStorageSettings.getSettings("WorkspaceId");
  const url = this.restAPI.GET_DEFAULT_ACTIVITIES.replace('{workSpaceId}', workSpaceId);
  return this.http.get<any>(
    url,
    { headers: this.headers }
  );
}


// Update Review Activity Config
updateReviewActivityConfig(id: number, payload: any): Observable<any> {
  const url = this.restAPI.UPDATE_ACTIVE_REVIEW_ACTIVITY_CONFIG.replace(
    '{id}',
    id.toString()
  );

  return this.http.post<JsignalInfo>(
    url,
    payload,
    { headers: this.headers }
  );
}

deleteReviewActivityConfig(id: number): Observable<any> {
  const url = this.restAPI.DELETE_ACTIVE_REVIEW_ACTIVITY_CONFIG.replace(
    '{id}',
    id.toString()
  );
  return this.http.post<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

// --------------------Signal Source Configuration ---------------------

createSignalSourceConfiguration(payload: any): Observable<any> {
  return this.http.post<JsignalInfo>(
    this.restAPI.CREATE_SIGNAL_SOURCE_CONFIGURATION,
    payload,
    { headers: this.headers }
  );
}

updateSignalConfigurationbasedOnType(id: number, payload: any): Observable<any> {
  const url = this.restAPI.UPDATE_SIGNAL_CONFIGURATION.replace(
    '{id}',
    id.toString()
  );
  return this.http.put<JsignalInfo>(
    url,
    payload,
    { headers: this.headers }
  );
}

delteSignalSourceConfiguration(id: number): Observable<any> {
  const url = this.restAPI.DELETE_SIGNAL_CONFIGURATION.replace(
    '{id}',
    id.toString()
  );
  return this.http.post<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}


getAllSignalSources(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_SIGNAL_SOURCES,
    { headers: this.headers }
  );
}

getValidationSla(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_VALIDATION_SLA,
    { headers: this.headers }
  );
}

// =====================Signal Management ===================================================

createSignal(payload:any):Observable<JsignalInfo>{
  return this.http.post<JsignalInfo>(
    this.restAPI.CREATE_SIGNAL,
    payload,
    {headers: this.headers}
  )
}

updateSignal(id:any,payload:any):Observable<JsignalInfo>{
  const url = this.restAPI.UPDATE_SIGNAL.replace(
    '{id}',
    id.toString()
  );
  return this.http.put<JsignalInfo>(
    url,
    payload,
    { headers: this.headers }
  );
}

deleteSignal(id:any):Observable<JsignalInfo>{
  const url = this.restAPI.DELETE_SIGNAL.replace(
    '{id}',
    id.toString()
  );
  return this.http.delete<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

assignUserToSignal(signalId: number, userId: string): Observable<any> {
  const url =this.restAPI.ASSIGN_USER_TO_SIGNAL.replace('{signalId}', signalId.toString()).replace('{userId}', userId);
    return this.http.post<JsignalInfo>(
    url,null,   
    { headers: this.headers }
    );
  }

getAllSignals():Observable<JsignalInfo>{
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_SIGNAL,
    { headers: this.headers }
  );
}

getSignalById(id: number):Observable<JsignalInfo>{
  const url = this.restAPI.GET_SIGNAL_BY_ID.replace('{id}', id.toString());
  return this.http.get<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

changeSignalStatus(signalId: number, signalStatusPayload:any):Observable<JsignalInfo>{
  const url = this.restAPI.CHANGE_SIGNAL_STATUS.replace('{id}', signalId.toString());
  return this.http.put<JsignalInfo>(
    url,
    signalStatusPayload,
    { headers: this.headers }
  );

}

getSignalCounts(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_SIGNAL_COUNTS,
    { headers: this.headers }
  );
}

// ========================= Signal Decision ===========================================

createSignalDecisionBasedOnSignalId(signalId: number, payload: any): Observable<JsignalInfo> {
  const url = this.restAPI.CREATE_SIGNAL_DECISION.replace('{signalId}', signalId.toString());
  return this.http.post<JsignalInfo>(
    url,
    payload,
    { headers: this.headers }
  );
}

getAllSignalDecisionsBasedOnSignalId(signalId: number): Observable<JsignalInfo> {
  const url = this.restAPI.GET_ALL_SIGNAL_DECISIONS.replace('{signalId}', signalId.toString());
  return this.http.get<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

updateSignalDecision(decisionId: number, payload: any): Observable<JsignalInfo> {
  const url = this.restAPI.UPDATE_SIGNAL_DECISION.replace('{id}', decisionId.toString());
  return this.http.put<JsignalInfo>(
    url,
    payload,
    { headers: this.headers }
  );
}

deleteSignalDecision(decisionId: number): Observable<JsignalInfo> {
  const url = this.restAPI.DELETE_SIGNAL_DECISION.replace('{id}', decisionId.toString());
  return this.http.delete<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

// ======================== Signal Attachment ===========================================

uploadSignalAttachments(
  signalId: number,
  productId: string,
  files?: File[],
  links?: any[]   // 👈 NEW
) {
  const formData = new FormData();

  const url = this.restAPI.UPLOAD_SIGNAL_ATTACHMENTS
    .replace('{signalId}', signalId.toString());

  // productId
  formData.append('productId', productId);

  // files
  if (files && files.length > 0) {
    files.forEach(file => {
      formData.append('attachments', file);
    });
  }

  // links (VERY IMPORTANT)
  if (links && links.length > 0) {
    formData.append('links', JSON.stringify(links)); // Convert links array to JSON string
  }

  return this.http.post(url, formData);
}

loadAttachmentData(signalId: number): Observable<any> {
  const url = this.restAPI.GET_SIGNAL_ATTACHMENTS.replace('{SignalId}', signalId.toString());
  return this.http.get<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

downloadAttachment(attachmentId: number) {
  const url = this.restAPI.DOWNLOAD_SIGNAL_ATTACHMENTS.replace('{attachmentId}', attachmentId.toString());
  return this.http.get(
    url,
    {
      responseType: 'blob',
      observe: 'response' //needed for headers
    }
  );
}

deleteAttachment(attachmentId: number): Observable<any> {
  const url = this.restAPI.DELETE_SIGNAL_ATTACHMENTS.replace('{attachmentId}', attachmentId.toString());
  return this.http.delete<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

getSignalLinksBasedOnSignalId(signalId: number): Observable<any>{
  const url = this.restAPI.GET_SIGNAL_LINKS.replace('{signalId}', signalId.toString());
  return this.http.get<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}


// ========================== Meetings =================================================================

getAllMeetings(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_MEETINGS,
    { headers: this.headers }
  );
}

createMeeting(payload: any): Observable<any> {
  return this.http.post<JsignalInfo>(
    this.restAPI.CREATE_MEETING,
    payload,
    { headers: this.headers }
  );
}

updateMeeting(id: number, payload: any): Observable<any> {
  const url = this.restAPI.UPDATE_MEETING.replace('{id}', id.toString());
  return this.http.put<JsignalInfo>(
    url,
    payload,
    { headers: this.headers }
  );
}

deleteMeeting(id: number): Observable<any> {
  const url = this.restAPI.DELETE_MEETING.replace('{id}', id.toString());
  return this.http.delete<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

getMeetingParticipants(meetingId: number): Observable<any> {
  const url = this.restAPI.GET_MEETING_PARTICIPANTS.replace('{id}', meetingId.toString());
  return this.http.get<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}
 
addParticipants(meetingId: number, userIds: number[]): Observable<any> {
  const url = this.restAPI.ADD_MEETING_PARTICIPANTS.replace('{id}', meetingId.toString());
  return this.http.post<JsignalInfo>(
    url,
    userIds,
    { headers: this.headers }
  );
}

removeParticipants(meetingId: number, userIds: number[]): Observable<any> {
  const url = this.restAPI.REMOVE_MEETING_PARTICIPANTS.replace('{id}', meetingId.toString());
  return this.http.delete<JsignalInfo>(
    url,
    { headers: this.headers, body: userIds }
  );
}

/* ================= CREATE ================= */
 createHaRequest(formData: FormData): Observable<any> {
  return this.http.post<any>(
    this.restAPI.CREATE_HA_REQUEST,
    formData
  );
}

  /* ================= READ ================= */
  getAllHaRequests(): Observable<any[]> {
    return this.http.get<any[]>(
      this.restAPI.GET_ALL_HA_REQUESTS,
      { headers: this.headers }
    );
  }

  /* ================= UPDATE ================= */
  updateHaRequest(id: any, payload: any): Observable<any> {
    const url = this.restAPI.UPDATE_HA_REQUEST.replace('{id}', id.toString());

    return this.http.put<any>(
      url,
      payload,
      { headers: this.headers }
    );
  }

  /* ================= DELETE ================= */
  deleteHaRequest(id: number): Observable<any> {
    const url = this.restAPI.DELETE_HA_REQUEST.replace('{id}', id.toString());

    return this.http.post<any>(
      url,
      { headers: this.headers }
    );
  }

getHaRequestById(id: number): Observable<any> {
  const url = this.restAPI.GET_HA_REQUEST_BY_ID.replace('{id}', id.toString());

  return this.http.get<any>(url, {
    headers: this.headers
  });
}
/* ================= SUB ACTION ================= */

createSubAction(requestId: any, payload: any) {
  const url = this.restAPI.CREATE_SUB_ACTION.replace('{requestId}', requestId.toString());

  return this.http.post<any>(url, payload, {
    headers: this.headers
  });
}

updateSubAction(id: number, payload: any) {
  const url = this.restAPI.UPDATE_SUB_ACTION.replace('{id}', id.toString());

  return this.http.put<any>(url, payload, {
    headers: this.headers
  });
}

deleteSubAction(id: number) {
  const url = this.restAPI.DELETE_SUB_ACTION.replace('{id}', id.toString());

  return this.http.delete<any>(url, {
    headers: this.headers
  });
}

/* ================= ATTACHMENTS ================= */


addAttachmentLink(requestId: any, payload: any) {
  const url = this.restAPI.ADD_ATTACHMENT_LINK
    .replace('{requestId}', requestId.toString());

  return this.http.post(url, payload);
}


deleteHAAttachment(id: number) {
  const url = this.restAPI.DELETE_ATTACHMENT
    .replace('{id}', id.toString());

  return this.http.delete(url);
}

/* ================= MULTIPLE FILES UPLOAD ================= */
uploadMultipleFiles(requestId: number | null, formData: FormData, dnsId: number): Observable<any> {
  const url = this.restAPI.UPLOAD_MULTIPLE_FILES
    .replace('{requestId}', requestId?.toString() || '')
    .replace('{dnsId}', dnsId.toString());

  return this.http.post<any>(url, formData);
}


/* ================= DOWNLOAD FILE ================= */
downloadFileAttachment(attachmentId: number): Observable<any> {
  const url = this.restAPI.DOWNLOAD_FILE_ATTACHMENT
    .replace('{attachmentId}', attachmentId.toString());

  return this.http.get(url, {
    responseType: 'blob',
    observe: 'response'
  });

 
}

/* ================= GET ALL ATTACHMENTS ================= */
getAllAttachments(requestId: number): Observable<any[]> {
  const url = this.restAPI.GET_ALL_ATTACHMENTS
    .replace('{requestId}', requestId.toString());

  return this.http.get<any[]>(url, {
    headers: this.headers
  });
}

assignUserToHA(requestId: number, userId: string): Observable<any> {
  const url =this.restAPI.ASSIGN_USER_TO_HA_REQUEST.replace('{requestId}', requestId.toString()).replace('{userId}', userId);
    return this.http.post<JsignalInfo>(
    url,null,   
    { headers: this.headers }
    );
  }

getHaRequestSummary(): Observable<any> {
  const url = this.restAPI.GET_HA_REQUEST_SUMMARY;
  return this.http.get(url, { headers: this.headers });
}

getSignalsByProductIds(productId,startDate:any,endDate:any): Observable<any> {
   let params: any = {
  productId: productId,
  startDate: startDate,
  endDate: endDate
};
  // const url = this.restAPI.GET_SIGNALS_BY_PRODUCTID.replace('{productId}', productId);;
  return this.http.get(this.restAPI.GET_SIGNALS_BY_PRODUCTID, {params,headers: this.headers });
}

getSignalCountByProductIds(productId:any,startDate:any,endDate:any): Observable<any> {
   let params: any = {
  productId: productId,
  startDate: startDate,
  endDate: endDate
};
  // const url = this.restAPI.GET_SIGNALS_BY_PRODUCTID.replace('{productId}', productId);;
  return this.http.get(this.restAPI.GET_SIGNAL_COUNT_BY_PRODUCTID, {params,headers: this.headers });
}

   getAllActivitesBasedOnRoleAndDateRange(role:any,startDate:any,endDate:any,productId:any): Observable<any> {

    let params: any = {
  role: role,
  startDate: startDate,
  endDate: endDate
};

if (productId) {
  params.productId = productId;
}

    // const url = this.restAPI.GET_ALL_SCHEDULED_REVIEW_ACTIVITIES.replace('{role}', role);
    return this.http.get<JsignalInfo>(this.restAPI.GET_ALL_SCHEDULED_REVIEW_ACTIVITIES_BY_DATERANGE, { params,headers: this.headers });
    } 
// =============================Formula Builder===========================================

createFormula(payload: any): Observable<any> {
  return this.http.post<JsignalInfo>(
    this.restAPI.CREATE_FORMULA,
    payload,
    { headers: this.headers }
  ); 
}

updateFormula(id: number, payload: any): Observable<any> {
  const url = this.restAPI.UPDATE_FORMULA.replace('{id}', id.toString());
  return this.http.put<JsignalInfo>(
    url,
    payload,
    { headers: this.headers }
  );
}

getAllFormulas(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_FORMULAS,
    { headers: this.headers }
  );
}

getFormulaById(id: number): Observable<any> {
  const url = this.restAPI.GET_FORMULA_BY_ID.replace('{id}', id.toString());
  return this.http.get<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

deleteFormula(id: number): Observable<any> {
  const url = this.restAPI.DELETE_FORMULA.replace('{id}', id.toString());
  return this.http.delete<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}
detectSignal(drug: string, event: string, method: string = 'all') {

  const url = this.restAPI.DETECT_SIGNAL;
  return this.http.get<any>(
   url,
    {
      params: {
        drug,
        event,
        method
      }
    }
  );
}
getAllAnalyses(): Observable<any[]> {
  
  const url = this.restAPI.GetAllAnalyses;
  return this.http.get<any[]>(url);
}

// NEW: Get analysis result by job ID
getAnalysisResult(jobId: number): Observable<any> {
  const url = this.restAPI.GetAnalysisResult;
  return this.http.get(url, {
    params: { jobId: jobId.toString() },
    observe: 'response' // This allows you to check status codes
  });
}

// ============================ Library Support=========================================================

getLibraryProducts(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_LIBRARY_PRODUCTS,
    { headers: this.headers }
  );
}

getProductDetailsById(productId: string): Observable<any> {
  const url = this.restAPI.GET_LIB_PRODUCT_DETAILS.replace('{productId}', productId);
  return this.http.get<JsignalInfo>(
    url,
    { headers: this.headers }
  );
}

getLibraryStudy(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_LIBRARY_STUDY,
    { headers: this.headers }
  );
}

getAllIMERecords(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_IME_RECORDS,
    { headers: this.headers }
  );
}

getAllDMERecords(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_DME_RECORDS,
    { headers: this.headers }
  );
}

getStudyDetailsById(studyId: string): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_LIBRARY_STUDY_BY_ID.replace('{studyId}', studyId),
    { headers: this.headers }
  );
}


// 🔹 Study Products
getStudyProductsById(studyId: string): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_LIBRARY_STUDY_PRODUCTS_BY_ID.replace('{studyId}', studyId),
    { headers: this.headers }
  );
}

// 🔹 Study Arms
getStudyArmsById(studyId: string): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_LIBRARY_STUDY_ARMS_BY_ID.replace('{studyId}', studyId),
    { headers: this.headers }
  );
}

// 🔹 Study Indications
getStudyIndicationsById(studyId: string): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_LIBRARY_STUDY_INDICATIONS_BY_ID.replace('{studyId}', studyId),
    { headers: this.headers }
  );
}

// 🔹 Study Registrations
getStudyRegistrationsById(studyId: string): Observable<any> {
  return this.http.get<any>(
    this.restAPI.GET_LIBRARY_STUDY_REGISTRATIONS_BY_ID.replace('{studyId}', studyId),
    { headers: this.headers }
  );
}

getAllROA(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_ROA,
    { headers: this.headers }
  );
}

getAllCodeList(): Observable<any> {
  return this.http.get<JsignalInfo>(
    this.restAPI.GET_ALL_CODELIST,
    { headers: this.headers }
  );
}

  formatValues(key: string): string {
  if (!key) {
    console.error(`${key} :  Received empty or undefined key for formatting.`);
    return '';
  }
  if (typeof key !== 'string') {
    console.error(`${key} : Expected string key but got ${typeof key}. Converting to string.`);
    key = String(key);
  }
  // Only transform if it contains __v or _
  if (key.includes('__v') || key.includes('_')) {
    return key
      .replace(/__v/g, '')        // remove __v
      .replace(/_/g, ' ')         // replace _ with space
      .replace(/\s+/g, ' ')       // clean extra spaces
      .trim()
      .replace(/\b\w/g, c => c.toUpperCase()); // capitalize
  }

  // capitalize first letter 
  return key.charAt(0).toUpperCase() + key.slice(1);
}

regenerateWordDocument(strategyId: number): Observable<any> {
  const url = this.restAPI.REGENRATE_PSS_WORD_DOCUMENT.replace('{strategyId}', strategyId.toString());
  return this.http.post<JsignalInfo>(
    url,
    { headers: this.headers }
  );
} 

getReportBasedOnTemplateId(templateId:any,instancedetailid:any): Observable<any> {
    let params: any = {
  instancedetailid: instancedetailid,
};
    // const url = this.restAPI.GET_ALL_SCHEDULED_REVIEW_ACTIVITIES.replace('{role}', role);
    return this.http.get<JsignalInfo>(this.restAPI.GET_REPORTS_BASED_ON_TEMPLATEID+'/'+templateId, { params,headers: this.headers });
}

downloadReportBaedOnTemplateId(templateId:any,instancedetailid:any){
    
  let params: any = {
  instancedetailid: instancedetailid,
};
    return this.http.get(this.restAPI.DOWNLOAD_REPORTS_BASED_ON_TEMPLATEID+'/'+templateId, {params, headers: this.headers, responseType: 'blob', observe: 'response' });
}

getReportTemplateDetailsBasedOnTemplateId(templateId:any): Observable<any> {
    // const url = this.restAPI.GET_ALL_SCHEDULED_REVIEW_ACTIVITIES.replace('{role}', role);
    return this.http.get<JsignalInfo>(this.restAPI.GET_REPORT_TEMPLATE_BASED_ON_TEMPLATE_ID+'/'+templateId, { headers: this.headers });
}

getDatasetDetailsOnDatasetId(datasetId:any): Observable<any> {
    // const url = this.restAPI.GET_ALL_SCHEDULED_REVIEW_ACTIVITIES.replace('{role}', role);
    return this.http.get<JsignalInfo>(this.restAPI.GET_DATASET_DETAILS_ON_DATASET_ID+'/'+datasetId, { headers: this.headers });
}

checkIfReportIsPresentORNot(reportName:any): Observable<any> {
  let params: any = {
  reportName: reportName,
};
    // const url = this.restAPI.GET_ALL_SCHEDULED_REVIEW_ACTIVITIES.replace('{role}', role);
    return this.http.get<JsignalInfo>(this.restAPI.GET_REPORT_DETAILS_BASED_ON_REPORT_NAME, { params,headers: this.headers });
}


//================================ IMDRF Browser===================================================

getImdrfHierarchy(code: string, releaseYear: string): Observable<any> {
  const params = new HttpParams()
      .set('hierarchy', code)
      .set('releaseYear', releaseYear);

  const url = this.restAPI.GET_IMDRF_HIERARCHY;
  return this.http.get<JsignalInfo>(url, { params, headers: this.headers });
}

// getAnnexReleaseMetadata(Annex: string): Observable<any> {
//   const params = new HttpParams()
//       .set('AnnexCode', Annex);

//   const url = this.restAPI.GET_ANNEX_RELEASE_METADATA;
//   return this.http.get<JsignalInfo>(url, { params, headers: this.headers });
// }

getSearchDataFromSelectedAnnex(searchTerm: string, annex: string, releaseYear: string): Observable<any> {
  const params = new HttpParams()
      .set('search', searchTerm)
      .set('annex', annex)
      .set('releaseYear', releaseYear);

  const url = this.restAPI.GET_SEARCH_TERM_CODE_FROM_ANNEX;
  return this.http.get<JsignalInfo>(url, { params, headers: this.headers });
}

getDetailsOfSelectedAnnexCode(code: string, releaseYear: string): Observable<any> {
  const url = this.restAPI.GET_TERM_DETAILS.replace('{code}', code).replace('{releaseYear}', releaseYear);
  return this.http.get<JsignalInfo>(url, { headers: this.headers });  
}

getImdrfReleaseYears(): Observable<any> {
  const url = this.restAPI.GET_IMDRF_RELEASE_YEARS;
  return this.http.get<JsignalInfo>(url, { headers: this.headers });  
}

getAnnexCodesForSelectedReleaseYear(releaseYear: string): Observable<any> {
  const params = new HttpParams()
      .set('releaseYear', releaseYear);
  const url = this.restAPI.GET_IMDRF_ANNEXX_CODE_BASED_ON_RELEASE_YEAR;
  return this.http.get<JsignalInfo>(url, { params, headers: this.headers });  
}

getMetaDataFilesListForGIvenReleaseYear(releaseYear: string): Observable<any> {
  const params = new HttpParams()
      .set('releaseYear', releaseYear);
  const url = this.restAPI.GET_METADATA_FILES_FOR_IMDRF_FOR_GIVEN_RELEASE_YEAR;
  return this.http.get<JsignalInfo>(url, { params, headers: this.headers });
}

downloadMetaDataFileForImdrf(releaseYear: string, fileType: string): Observable<any> {
  const params = new HttpParams()
      .set('releaseYear', releaseYear)
      .set('fileType', fileType);
  const url = this.restAPI.DOWNLOAD_METADATA_FILES_FOR_IMDRF_FOR_GIVEN_RELEASE_YEAR;
  return this.http.get(url, { params, headers: this.headers, responseType: 'blob', observe: 'response' });
}

}

